<template>
	<div class="home" v-show="pageShow" :class="{ disabledScroll: showTimePage }" ref="homePage">
		<div>
			<div class="logo-img">
				<img src="../assets/images/logo.svg" alt />
			</div>
			<div class="kv">
				<img src="../assets/images/kv.jpg" alt />
			</div>
			<div class="container">
				<div class="title">{{ projectName }}</div>
				<!-- <div class="title">
					<img src="../assets/images/title.png" />
				</div> -->
				<div class="date">{{ cityInfo.startTime }}-{{ cityInfo.endTime }}</div>
				<div class="address">{{ cityInfo.city }}</div>
				<div class="tip-info">请填写联系方式并选择到场时间</div>

				<form class="form" action ref="form">
					<div class="form-groups">
						<div class="pre-label" ref="name">姓名*</div>
						<div class="input-box">
							<input
								id="name"
								name="name"
								type="text"
								data-validate="true"
								data-methods="notNull|name"
								data-type="name"
								data-placeholder="姓名*"
								placeholder="姓名*"
								v-model="model.name"
								class="name"
								:class="{ isAndroid: !isIos }"
								@blur="blur"
							/>
						</div>
						<div class="label" ref="nameLabel"></div>
					</div>
					<div class="form-groups">
						<div class="pre-label" ref="phone">手机号码*</div>
						<div class="input-box">
							<input
								id="mobile"
								pattern="[0-9]*"
								name="mobile"
								type="text"
								autocomplete="off"
								onkeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
								oninput="if(value.length>11)value=value.slice(0,11)"
								maxlength="11"
								data-validate="true"
								data-methods="notNull|phone"
								data-type="phone"
								data-placeholder="手机号码*"
								placeholder="手机号码*"
								v-model="inputPhone"
								@blur="blur"
							/>
						</div>
						<div class="label" ref="phoneLabel"></div>
					</div>
					<div class="form-groups">
						<div class="pre-label">验证码*</div>
						<div class="input-box">
							<input
								pattern="[0-9]*"
								id="testCode"
								ref="codePut"
								name="testCode"
								type="text"
								onkeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
								oninput="if(value.length>4)value=value.slice(0,4)"
								data-validate="true"
								data-methods="notNull|testCode"
								data-type="testCode"
								data-placeholder="验证码*"
								placeholder="验证码*"
								v-model="model.testCode"
								@blur="blur"
							/>
							<div
								class="get-btn"
								@click="_getCode"
								:class="{ disabled: !phone_test || count_down < 61 }"
							>
								<div class="box">
									<span v-if="count_down === 61">获取验证码</span>
									<span v-else>重新获取({{ count_down }}s)</span>
								</div>
							</div>
						</div>
						<div class="label" ref="codeTip"></div>
					</div>
					<div class="form-groups">
						<div class="pre-label" :class="{ 'time-show': model.time }">
							到场时间*
						</div>
						<div class="input-box select">
							<div class="box-shadow" @click="timeSelShow"></div>

							<input
								id="time"
								type="text"
								name="time"
								ref="timeOption"
								readonly
								v-model="model.time"
								@blur="blur"
								placeholder="选择到场时间*"
							/>
						</div>
						<div class="label" ref="timeLabel"></div>
					</div>
				</form>
				<div class="privacy">
					<div class="sel-box" @touchend="selPrivacy" ref="privacy">
						<div class="selected-box" v-if="sel_privacy"></div>
					</div>
					<div class="text">
						香奈儿重视您的隐私。在您申请注册并点击同意前，我们建议您认真阅读<a
							href="https://www.chanel.cn/zh_CN/#privacy"
							:class="{ isAndroid: !isIos }"
							>隐私政策</a
						>并充分理解相关条款内容。该<a
							href="https://www.chanel.cn/zh_CN/#privacy"
							:class="{ isAndroid: !isIos }"
							>隐私政策</a
						>涉及对您的个人资料进行采集、使用、分享等详细说明。当您填写注册信息、阅读并点击同意隐私政策后，即表示您已充分阅读、理解并接受隐私政策的全部内容。
					</div>
				</div>
				<div class="submit" v-if="confirmSubmit" :class="{ disabled: !canSubmit }" @click="submit">
					确认
				</div>
				<div class="submit gray" v-else>确认</div>
			</div>
		</div>

		<time-page
			ref="timePage"
			v-if="hasData"
			:showTimePage.sync="showTimePage"
			:dateArray.sync="dateArray"
			:channel="channel"
			@timeSel="timeSel"
		></time-page>
	</div>
</template>

<script>
// @ is an alias to /src
import Validate from '@/assets/js/validate.js'
import { Utils } from '@/assets/js/utils.js'
import { getSceneInfo, getCrm, isExist, getCode, commit } from '@/assets/js/api.js'
import { setInterval, clearInterval, setTimeout } from 'timers'
import { findAll } from '@/assets/js/api.js'
import TimePage from '@/components/time/Time'
import moment from 'moment'
export default {
	name: 'home',
	components: {
		TimePage,
	},
	data() {
		return {
			sel_privacy: false,
			model: {
				name: null,
				phone: '',
				testCode: null,
				time: '',
			},
			cityInfo: {
				city: '',
				address: '',
				startTime: '',
				endTime: '',
			},
			phone_test: false,
			openId: '',
			count_down: 61,
			channel: '',
			sceneId: 1,
			city: 'default',
			canSubmit: true,
			type: 0, // 用户类型 0 是普通 1是会员
			pageShow: false,
			showTimePage: false,
			confirmSubmit: false,
			dateArray: {},
			hasData: false,
			isSelectedSpecial: 0, //是否选择特殊服务
			bookingSpecialServeId: 0,
			axiosSceneCount: 0,
			axiosOpacityCount: 0,
			isIos: true,
			toCode: false,
			selTimeObj: {},
		}
	},
	created() {
		let to = this.$route
		const localData = JSON.parse(localStorage.getItem('n5-holiday-podium'))
		let channel = Utils.parseQuery().channel || to.query.channel || 'ds'
		let discern = to.query.discern || (localData && localData.discern)
		let sceneId = to.query.sceneId || (localData && localData.sceneId)
		if (discern) {
			this.toCode = true
			this.$router.replace({
				path: '/code',
				query: { discern, sceneId, channel },
			})
			return false
		}
		this.isIos = Utils.isIos()
	},
	computed: {
		inputPhone: {
			get() {
				return this.model.phone
			},
			set(val) {
				this.model.phone = val
			},
		},
	},
	mounted() {
		if (!this.toCode) {
			this.$nextTick(async () => {
				await this._getSceneInfo()
				// 获取当前页面url信息
				await this.currentPageChannel()
				// 表单验证
				let form = this.$refs.form
				const valid = new Validate(form)
				valid.valid()
			})
		}
	},
	methods: {
		async _getSceneInfo() {
			// 获取对应场次信息
			this.sceneId = Utils.parseQuery().sceneId || 1
			try {
				const { data } = await getSceneInfo({ sceneId: this.sceneId })
				if (data.message.code === '00000') {
					const { payload } = data
					if (data.message.responseTime > payload.sceneEndTimestamp) {
						this.$router.replace('/over')
					}
					this.cityInfo = {
						city: payload.site,
						address: payload.address,
						startTime:
							moment(payload.sceneStartTimestamp).format('M') +
							'月' +
							moment(payload.sceneStartTimestamp).format('D') +
							'日',
						endTime:
							moment(payload.sceneEndTimestamp).format('M') +
							'月' +
							moment(payload.sceneEndTimestamp).format('D') +
							'日',
					}
				}
			} catch (err) {
				console.log(err)
				if (this.axiosSceneCount >= 1) {
					this.$router.replace('/over')
				}
				if (this.axiosSceneCount < 1) {
					this._getSceneInfo()
					this.axiosSceneCount = 1
				}
			}
		},
		blur() {
			this._confirmSubmit()
		},
		_confirmSubmit() {
			// 验证通过，提交数据
			setTimeout(() => {
				if (
					this.model.name &&
					this.model.phone &&
					this.model.testCode &&
					this.selTimeObj.id &&
					this.sel_privacy &&
					!this.labelStatus()
				) {
					this.confirmSubmit = true
				} else {
					this.confirmSubmit = false
				}
			})
		},
		labelStatus() {
			let hasBlock = false
			const label = document.querySelectorAll('.label')
			Array.from(label).forEach((item) => {
				if (item.style.display == 'block') {
					hasBlock = true
				}
			})
			return hasBlock
		},
		timeSelShow() {
			this.showTimePage = true
		},
		timeSel(obj) {
			const { dateData, bookingSpecialServe } = obj
			let hasSpecial = ''
			if (bookingSpecialServe.id) {
				this.bookingSpecialServeId = bookingSpecialServe.id
				this.isSelectedSpecial = 1
				let time = Number(bookingSpecialServe.specialTime.slice(0, 2))
				hasSpecial = `(含彩妆秀 ${time}:00)`
			} else {
				this.bookingSpecialServeId = 0
				this.isSelectedSpecial = 0
				hasSpecial = ''
			}

			this.selTimeObj = dateData
			this.model.time = `${dateData.month}月${dateData.date}日 周${dateData.week} ${hasSpecial}`
			this._confirmSubmit()
		},
		optionDisabled() {
			const opts = document.querySelectorAll('option')
			Array.from(opts).forEach((item) => {
				if (item.dataset.disabled == 'true') {
					item.disabled = true
				} else {
					item.removeAttribute('disabled')
				}
			})
		},
		async setOption() {
			try {
				const { data } = await findAll({ sceneId: this.sceneId })
				if (data.message.code === '00000') {
					this.dateArray = data.payload
					this.hasData = JSON.stringify(data.payload) != '{}'
				} else if (data.message.code === '30102') {
					this.$router.replace('/over')
				} else {
					alert('预约时间获取失败')
				}
			} catch (err) {
				console.log(err)
				if (this.axiosOpacityCount >= 1) {
					this.$router.replace('/over')
				}
				if (this.axiosOpacityCount < 1) {
					this.setOption()
					this.axiosOpacityCount = 1
				}
			}
		},
		// 获取href信息
		async currentPageChannel() {
			let channel = Utils.parseQuery().channel || 'ds'
			this.channel = channel.toLocaleLowerCase()
			// 获取openId, crm用户信息
			if (this.channel == 'crm') {
				this.type = 1
				try {
					await this.getCrmInfo()
				} catch (err) {
					console.log(err)
				}
			} else if (this.channel == 'sms') {
				// 获取日期，时间段
				await this.setOption()
				this.type = 1
				this.pageShow = true
			} else {
				// 获取日期，时间段
				await this.setOption()
				this.type = 0
				this.pageShow = true
			}
			if (this.pageShow) {
				Utils.scrollFix(this.$refs.homePage)
				Utils.cursorFix(this.$refs.homePage)
			}
		},
		async getCrmInfo() {
			let code = Utils.parseQuery().code || '00'
			if (code) {
				try {
					const { data } = await getCrm({
						code,
						sceneId: this.sceneId,
					})
					if (data.message.code == '00000') {
						const { payload } = data
						if (payload.firstname) {
							this.model.name = payload.lastname + payload.firstname
							this.model.phone = payload.tel
							this.$refs.name.style.opacity = 1
							this.$refs.phone.style.opacity = 1
						}
						this.openId = payload.openId
						this.unionid = payload.unionid
					}
				} catch (err) {
					console.log(err)
				}
			}
			await this.setOption()
			this.pageShow = true
		},
		//检测用户是否存在
		async _isExist() {
			try {
				const { data } = await isExist({
					phone: this.model.phone,
					sceneId: this.sceneId,
				})
				if (data.message.code === '00000') {
					this.phone_test = true
				} else if (data.message.code == '00101') {
					this.$refs.phoneLabel.innerHTML = '该号码已存在'
					this.$refs.phoneLabel.style.display = 'block'
					this.phone_test = false
				}
			} catch (err) {
				console.log(err)
			}
		},
		//获取验证码
		_getCode() {
			if (this.canSubmit) {
				this.canSubmit = false
				this.count_down--
				let interval = setInterval(() => {
					this.count_down--
					if (this.count_down === 0) {
						this.count_down = 61
						clearInterval(interval)
					}
				}, 1000)
				getCode({ phone: this.model.phone, sceneId: this.sceneId })
				setTimeout(() => {
					this.canSubmit = true
				}, 1000)
			}
		},
		selPrivacy() {
			this.sel_privacy = !this.sel_privacy
			if (this.sel_privacy) this.$refs.privacy.style.borderColor = '#eaeaea'
			this._confirmSubmit()
		},
		async submit() {
			// 表单验证
			let form = this.$refs.form
			const valid = new Validate(form)
			// 验证通过，提交数据
			if (this.canSubmit) {
				this.canSubmit = false
				if (valid.init() && this.sel_privacy && this.selTimeObj.id) {
					const datas = {
						sceneId: this.sceneId,
						nickname: this.model.name,
						phone: this.model.phone,
						captcha: this.model.testCode,
						openId: this.openId,
						bookingTimeId: this.selTimeObj.id,
						type: this.type,
						channel: this.channel,
						isSelectedSpecial: this.isSelectedSpecial,
						bookingSpecialServeId: this.bookingSpecialServeId,
					}
					try {
						const result = await commit(datas)
						const { data } = result
						switch (data.message.code) {
							case '00100': {
								const { payload } = data
								const local = {
									channel: this.channel,
									discern: payload.discern,
									sceneId: this.sceneId,
								}
								localStorage.setItem('n5-holiday-podium', JSON.stringify(local))
								this.$router.replace({
									path: '/code',
									query: {
										discern: payload.discern,
										sceneId: this.sceneId,
										channel: this.channel,
									},
								})
								break
							}

							case '30201':
								this.$refs.codeTip.innerHTML = '验证码错误'
								this.$refs.codePut.style.borderColor = 'rgb(213, 5, 5)'
								this.$refs.codeTip.style.display = 'block'
								break
							case '30200':
								this.$refs.codeTip.innerHTML = this.$t('codeTimer')
								this.$refs.codePut.style.borderColor = 'rgb(213, 5, 5)'
								this.$refs.codeTip.style.display = 'block'
								break
							case '30101': //某个日期约满
								alert('您预约的日期已满')
								await this.setOption()
								this.$refs.timePage.initData(this.dateArray)
								break
							case '30103': //彩妆秀-某个日期约满
								alert('您预约的彩妆秀时间段已满')
								await this.setOption()
								this.$refs.timePage.initData(this.dateArray)
								break
							default:
								break
						}
					} catch (err) {
						console.log(err)
					}
				} else if (!this.sel_privacy) {
					this.$refs.privacy.style.borderColor = 'red'
				}
				setTimeout(() => {
					this.canSubmit = true
				}, 1000)
			}
		},
	},
	watch: {
		inputPhone(newVal) {
			let phone = newVal
			if (phone.length > 11) {
				this.model.phone = phone.slice(0, 11)
			}
			if (this.model.phone.length === 11) {
				if (/^1[3456789]\d{9}$/.test(phone)) {
					this._isExist()
				}
			} else {
				this.phone_test = false
			}
		},
	},
}
</script>
<style lang="stylus" scoped>
@import '~assets/stylus/mixin';

input:focus, select:focus {
  border-color: #000 !important;
}

.outer {
  width: 100%;
  height: 100%;
  overflow: scroll;
}

.home {
  padding-top: 32px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;

  &.disabledScroll {
    overflow: hidden;
  }

  .disabled {
    pointer-events: none;
  }

  img {
    max-width: 100%;
  }

  .logo-img {
    width: 150px;
    margin: 0 auto 32px;
  }

  .kv {
    img {
      width: 100%;
    }
  }

  .container {
    padding-top: 40px;
    padding-bottom: 32px;

    .title {
      font-size: 24px;
      line-height: 24px;
      text-align: center;
      white-space: nowrap;
      letter-spacing: 1px;
      font-family: PingFangSC-Medium, 'PingFangH';
      img {
        width: 273px
        margin: 0 auto;
      }
    }

    .date, .address {
      font-size: 16px;
      line-height: 16px;
      font-family: PingFangSC-Medium, 'PingFangH';
    }

    .date {
      text-align: center;
      margin-top: 32px;
      transform: translateY(-2px)
    }

    .address {
      text-align: center;
      margin-top: 12px;
      letter-spacing: 0.44px;
    }

    .tip-info {
      text-align: center;
      margin: 32px 0 28px;
      font-size: 14px;
      line-height: 14px;
      color: #919191;
      letter-spacing: 0.5px;
    }

    .form {
      display: block;
      width: 327px;
      margin: 0 auto;

      .form-groups {
        width: 100%;
        margin-top: 18px;
        box-sizing: border-box;

        .pre-label {
          font-size: 12px;
          line-height: 12px;
          color: #767676;
          letter-spacing: 0.1px;
          opacity: 0;

          &.time-show {
            opacity: 1;
          }
        }

        .label {
          color: #D00000;
          font-size: 12px;
          padding-top: 12px;
          line-height: 12px;
          display: none;
        }

        .select {
          position: relative;
          color: #000;

          &::before {
            content: '';
            display: block;
            width: 8px;
            height: 8px;
            border: 1px solid #767676;
            border-top: 0;
            border-left: 0;
            position: absolute;
            right: 2px;
            top: 14px;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
          }

          .box-shadow {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
          }
        }

        select {
          position: relative;
          display: block;
          width: 100%;
          height: 100%;
          border: 0;
          font-size: 14px;
          color: #999;
          padding: 0 11px;
          box-sizing: border-box;
          background-color: transparent;
          border: 1px solid #eaeaea;
        }

        .input-box {
          width: 100%;
          height: 39px;
          position: relative;
          overflow: hidden;

          input {
            display: block;
            width: 100%;
            height: 38px;
            border: 0;
            padding: 0;
            font-size: 14px;
            border: 0;
            border-bottom: 1px solid #eaeaea;
            font-family: PingFangSC-Medium, 'PingFangH';
          }

          .name {
            font-family: PingFangSC-Medium, sans-serif;

            &.isAndroid {
              font-weight: bold;
            }
          }
        }

        .get-btn {
          font-size: 14px;
          height: 100%;
          position: absolute;
          right: 0;
          top: 0;
          width: 90px;
          z-index: 10;

          .box {
            width: 100%;
            height: 100%;
            center-center();
            justify-content: flex-end;
          }

          span {
            display: inline;
            white-space: nowrap;
            line-height: 16px;
            text-align: center;
            color: #767676;
            transform: translateY(-1px)
          }
        }
      }
    }

    .privacy {
      font-size: 12px;
      color: #999;
      width: 327px;
      margin: 32px auto 0;
      display: flex;
      line-height: 18px;

      .sel-box {
        width: 20px;
        height: 20px;
        border: 1px solid #eaeaea;
        box-sizing: border-box;
        flex: 0 0 20px;
        margin-right: 12px;
        margin-top: 3px;
        center-center();

        .selected-box {
          width: 10px;
          height: 10px;
          background: #000000;
        }
      }

      .text {
        text-align: justify;
        letter-spacing: 0.1px;

        .isAndroid {
          line-height: 10px;
          height: 10px;
        }

        a {
          color: #919191;
          text-decoration: none;
          line-height: 14px;
          height: 14px;
          border-bottom: 1px solid #999;
          display: inline-block;
        }
      }
    }

    .submit {
      width: 327px;
      height: 44px;
      background: #000000;
      color: #ffffff;
      margin: 32px auto 0;
      font-size: 14px;
      center-center();

      &.disabled {
        pointer-events: none;
      }

      &.gray {
        background: #ACACAC;
      }
    }
  }
}
</style>
